export default __webpack_public_path__ + "static/media/personal 1.51516066.svg";